import type { GeoAnalyticsThemeMode } from "@/theme/tokens";

type GeoVisualAssetKind = "header" | "detail" | "logo" | "loader";

export const geoVisualAssets: Record<GeoVisualAssetKind, Record<GeoAnalyticsThemeMode, string>> = {
  header: {
    light: "/images/svg/header_l.svg",
    dark: "/images/svg/header_b.svg"
  },
  detail: {
    light: "/images/svg/detail_l.svg",
    dark: "/images/svg/detail_b.svg"
  },
  logo: {
    light: "/images/svg/logo_l.svg",
    dark: "/images/svg/logo_b.svg"
  },
  loader: {
    light: "/images/gifs/loader_l.gif",
    dark: "/images/gifs/loader_b.gif"
  }
};

export const geoVisualAssetOpacity: Record<GeoAnalyticsThemeMode, number> = {
  light: 0.22,
  dark: 0.18
};

export const geoDetailDecorOpacity: Record<GeoAnalyticsThemeMode, number> = {
  light: 0.04,
  dark: 0.035
};

export function getGeoVisualAsset(kind: GeoVisualAssetKind, mode: GeoAnalyticsThemeMode) {
  return geoVisualAssets[kind][mode];
}

export const geoDocumentAssets: Record<
  GeoAnalyticsThemeMode,
  {
    faviconIco: string;
    favicon16: string;
    favicon32: string;
    favicon96: string;
    appleTouchIcon: string;
    browserConfig: string;
    tileImage: string;
    themeColor: string;
  }
> = {
  light: {
    faviconIco: "/icons/web/favicon.ico",
    favicon16: "/icons/web/favicon-16x16.png",
    favicon32: "/icons/web/favicon-32x32.png",
    favicon96: "/icons/web/favicon-96x96.png",
    appleTouchIcon: "/icons/app/apple-icon-180x180.png",
    browserConfig: "/icons/app/browserconfig.xml",
    tileImage: "/icons/app/ms-icon-144x144.png",
    themeColor: "#315F46"
  },
  dark: {
    faviconIco: "/icons/web/favicon.ico",
    favicon16: "/icons/web/favicon-16x16.png",
    favicon32: "/icons/web/favicon-32x32.png",
    favicon96: "/icons/web/favicon-96x96.png",
    appleTouchIcon: "/icons/app/apple-icon-180x180.png",
    browserConfig: "/icons/app/browserconfig.xml",
    tileImage: "/icons/app/ms-icon-144x144.png",
    themeColor: "#0E1511"
  }
};
